import type { DocTreeNode } from './types';

/**
 * Ancestor node keys (Domain, System) whose subtree contains `entityRef`, so
 * a tree can open just the branch leading to whichever doc is currently open
 * instead of expanding — or leaving collapsed — everything.
 */
export function findActivePath(
  nodes: DocTreeNode[],
  entityRef: string,
): Set<string> {
  const path = new Set<string>();

  const visit = (node: DocTreeNode): boolean => {
    const ownMatch = node.entity?.entityRef === entityRef;
    const entityMatch = node.entities.some(
      entity => entity.entityRef === entityRef,
    );
    const childMatch = node.children.reduce(
      (found, child) => visit(child) || found,
      false,
    );

    if (ownMatch || entityMatch || childMatch) {
      path.add(node.key);
      return true;
    }
    return false;
  };

  nodes.forEach(visit);
  return path;
}
